var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLangEn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_5508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 4.5H0V27.5H32V4.5Z",
    fill: "url(#paint0_linear_1782_5508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9971 4.5H-0.00292969V27.5H31.9971V4.5Z",
    fill: "url(#paint1_linear_1782_5508)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62417 19.8333H-0.00296584V12.1667H7.62417L-3.17285 4.83847L-1.46864 2.29609L12.1875 11.5648V2.96667H19.8066V11.5648L33.4627 2.29609L35.1669 4.83847L24.3699 12.1667H31.997V19.8333H24.3699L35.1669 27.1615L33.4627 29.7039L19.8066 20.4351V29.0333H12.1875V20.4351L-1.46864 29.7039L-3.17285 27.1615L7.62417 19.8333Z",
    fill: "url(#paint2_linear_1782_5508)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5415 12.1023L36.0162 2.52025C36.192 2.40389 36.2408 2.16619 36.1251 1.98932C36.0095 1.81245 35.7733 1.7634 35.5975 1.87975L21.1228 11.4618C20.947 11.5781 20.8983 11.8158 21.0139 11.9927C21.1295 12.1696 21.3658 12.2186 21.5415 12.1023Z",
    fill: "#DB1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6559 20.57L35.6317 29.3708C35.8061 29.4891 36.0429 29.4427 36.1605 29.2671C36.2781 29.0916 36.232 28.8534 36.0575 28.735L23.0817 19.9343C22.9072 19.8159 22.6705 19.8623 22.5529 20.0379C22.4353 20.2134 22.4814 20.4517 22.6559 20.57Z",
    fill: "#DB1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35924 11.4392L-4.17564 2.26049C-4.35011 2.14217 -4.58687 2.18858 -4.70445 2.36414C-4.82203 2.5397 -4.77591 2.77794 -4.60144 2.89625L8.93344 12.0749C9.10791 12.1932 9.34466 12.1468 9.46225 11.9713C9.57983 11.7957 9.53371 11.5575 9.35924 11.4392Z",
    fill: "#DB1F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4038 19.8262L-4.59908 29.8376C-4.77442 29.9546 -4.8223 30.1925 -4.70602 30.3689C-4.58974 30.5453 -4.35334 30.5935 -4.178 30.4765L10.8249 20.4651C11.0002 20.3481 11.0481 20.1102 10.9318 19.9338C10.8156 19.7573 10.5791 19.7092 10.4038 19.8262Z",
    fill: "#DB1F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00292969 18.3H13.7114V27.5H18.2828V18.3H31.9971V13.7H18.2828V4.5H13.7114V13.7H-0.00292969V18.3Z",
    fill: "url(#paint3_linear_1782_5508)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1782_5508",
    x1: 16,
    y1: 4.5,
    x2: 16,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1782_5508",
    x1: 15.9971,
    y1: 4.5,
    x2: 15.9971,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A17A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030E88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1782_5508",
    x1: 15.997,
    y1: 2.29609,
    x2: 15.997,
    y2: 29.7039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1782_5508",
    x1: 15.9971,
    y1: 4.5,
    x2: 15.9971,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6273E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF152B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_5508"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4.5,
    width: 32,
    height: 23,
    rx: 4,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLangEn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_lang_en.43282fcac5f6358aca45a82e206f2d4f.svg";